import { render } from "./transfer-acquiring-confrim.vue?vue&type=template&id=258f6f7c&ts=true"
import script from "./transfer-acquiring-confrim.vue?vue&type=script&lang=ts"
export * from "./transfer-acquiring-confrim.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__